import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import { Grid, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ButtonTheme from "../ThemeButton/ThemeButton";
import Error from "../Error/Error";
import { toast } from 'react-toastify';

export default function EditConfig({ editItem, CloseEditMode, loadData }) {
  const [loading, setLoading] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState();
  // const { enqueueSnackbar } = useSnackbar();
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    reset,
    isValid,
  } = useForm({
    defaultValues: editItem ? { ...editItem } : {},
  });

  useEffect(() => {
    setEffectiveDate(new Date(editItem.Effective_Date, "YYYY-MM-DD"));
  }, []);
  const onSubmit = async (data) => {
    setLoading(true);
    await ApiService.post("/editSystemConfig", data)
      .then((data) => {
        setLoading(false);
        CloseEditMode();
        toast.success("Added successfully")
        // enqueueSnackbar("added successfully", { variant: "success" });
        loadData();
      })
      .catch(({ data }) => {
        if (data.errors) {
          Object.entries(data.errors).forEach((value) => {
            setError(value[0], { message: value[1] });
          });
        }
        setLoading(false);
      });
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}>
          <Grid item xs={4}>
            <TextField
              className="w-100"
              disabled={true}
              label="Var"
              value={editItem && editItem.Var}
            />
          </Grid>
          <Grid item xs={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Effective Date"
                disabled={true}
                value={new Date(editItem.Effective_Date)}
                sx={{ width: "100%" }}
              // dateInputIcon={<CalendarTodayIcon />}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={4}>
            <TextField className="w-100" label="Type" {...register("Type")} />
            {errors.Type && <Error>{errors.Type?.message}</Error>}
          </Grid>
          <Grid item xs={4}>
            <TextField
              className="w-100"
              label="Options"
              {...register("Options")}
            />
            {errors.Options && <Error>{errors.Options?.message}</Error>}
          </Grid>
          <Grid item xs={4}>
            <TextField
              className="w-100"
              label="Value"
              {...register("Value", { required: "Value is required" })}
            />
            {errors.Value && <Error>{errors.Value?.message}</Error>}
          </Grid>
          <Grid item xs={4} md={8}>
            <ButtonTheme
              type="submit"
              color="primary"
              // isSendToRequired &&
              disabled={isValid == true || loading}
              style={{
                width: "140px",
                textTransform: "capitalize",
              }}
            >
              Save
            </ButtonTheme>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
